import React, { useState, useEffect } from "react";
import { withRouter, Link } from "react-router-dom";
import moment from "moment";
import _ from "lodash";
import { newFetch, GET } from "../../helpers/fetch";
import PageShell, { EmptyState } from "../../components/UI/PageShell";

const Events = ({ history, sites }) => {
  const [events, setEvents] = useState([]);

  const activeSite = localStorage.getItem("default_site_id")
      ? Number(localStorage.getItem("default_site_id"))
      : null;
  const [defaultSiteData, setDefaultSiteData] = React.useState(null);
  const defaultSiteHandler = () =>
    setDefaultSiteData(sites.find((site) => site.id === activeSite));

  const fetchEvents = async () => {
    let api_path = "/event";
    let response = await newFetch(GET, api_path);

    if (response.success) {
      let eventsData = response.data;

      // get monthYears
      let monthYears = [
        ...new Set(
          eventsData.map((event) => moment(event.date).format("MMMM YYYY"))
        ),
      ].sort((a, b) => moment(b, "MMMM YYYY") - moment(a, "MMMM YYYY"));

      let eventsByMonthYear = monthYears.map((monthYear) => ({
        monthYear,
        events: eventsData
          .filter(
            (event) => moment(event.date).format("MMMM YYYY") === monthYear
          )
          .sort((a, b) => moment(b.date) - moment(a.date)),
      }));

      setEvents(eventsByMonthYear);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  React.useEffect(() => {
    sites && defaultSiteHandler();
  }, [sites]);

  return (
    <PageShell
      title="Events"
      eyebrow="What’s happening"
      description="Browse upcoming activities and workplace events."
    >
      <div className="portal-content-card">
        <div className="portal-list">
        {events &&
          events.map((month) => (
            <div key={`month-${month.monthYear}`}>
              <h6 className="portal-list-section-title">{month.monthYear}</h6>
              {month.events.map((event) => (
                <button
                  type="button"
                  className="portal-list-item portal-event-card"
                  onClick={() => history.push(`/events/event/${event.id}`)}
                  key={`event-${event.id}`}
                >
                  <span className="portal-event-card__date">
                        <strong>
                          {moment(event.date).format("DD")}
                        </strong>
                        <small>
                          {moment(event.date).format("MMM")}
                        </small>
                  </span>
                  <span className="portal-event-card__copy">
                      <strong>{event.title}</strong>
                      <small className="text-muted w-100">
                        {_.truncate(event.description, { length: 38 })}
                      </small>
                  </span>
                  <i className="fas fa-chevron-right" aria-hidden="true" />
                </button>
              ))}
            </div>
          ))}
        {!events.length && (
          <EmptyState
            icon="fa-calendar-day"
            title="No events available"
            description="New workplace events will appear here when they are published."
          />
        )}
        </div>
      </div>
    </PageShell>
  );
};

export default withRouter(Events);
